export default __webpack_public_path__ + "static/qrm-presentation-by-a72fcbf7b707290d803f74e3bd69954f.png";